import { useState, useEffect } from 'react';
import { Card, Typography } from '@mui/material';
import styled from 'styled-components';

import { AdminUserDetailsInterface } from '../../Models/AdminUserControl/AdminUserControl';

import RequiredParametersHelper from '../../Utilities/Helpers/RequiredParametersHelper';

import { ButtonType } from '../../Utilities/Enums/ButtonTypeEnum';
import { ViewType } from '../../Utilities/Enums/ViewTypeEnum';
import { AdminUserField, AdminUserProfileField } from '../../Utilities/Enums/ParametersEnum';
import { RouteEnum } from '../../Utilities/Enums/RouteEnums';

import FormTextField from '../../CustomViews/Elements/FormTextField';
import CustomButton from '../../CustomViews/Elements/CustomButton';
import CustomDetailsCard from '../../CustomViews/Pages/CustomDetailsCard/CustomDetailsCard';

const FormFieldItemsContainer = styled(Card) <{ $darkMode?: boolean; }>`
    box-shadow: none !important;
    background: transparent !important;
    width: 100%;
    display: flex;
    justify-content: space-between;

    .twofaTextContainer {
        .twofaText {
            font-size: 14px !important;
            font-weight: 600 !important;
        }

        .twofaTextDescription {
            font-size: 0.825rem !important;
            font-weight: 400 !important;
            color: #878a99 !important;
        }
    }
`;

const FieldItemValue = styled(Typography) <{ $darkMode?: boolean; }>`
    box-shadow: none !important;
    background: transparent !important;
    font-weight: 500 !important;
    font-size: 16px !important;
`;

export default function AdminUserSecurity(props: AdminUserDetailsInterface) {
    //Variables
    let { viewType, previewData, formData, setformData, errorMessages, DropdownData, dropdownFetchStatus, setopenQRCodeModal, routePath } = props;
    let requiredFields = RequiredParametersHelper.adminUserControl();

    //Use States

    //Event Handlers

    //Rendering Functions
    return <CustomDetailsCard
        title={"Security"} >
            <FormFieldItemsContainer>
                <div className="twofaTextContainer">
                    <Typography className="twofaText" color="primaryText">Two-factor Authentication</Typography>
                    <Typography className="twofaTextDescription">Two-factor authentication (2FA) is an identity and access management security method that requires two forms of identification to access resources and data.</Typography>
                </div>

                <CustomButton
                    btnType={(viewType == ViewType.PREVIEW || routePath == RouteEnum.ADMIN_USER_DETAILS) ? ButtonType.CANCEL : formData?.[AdminUserField.ENABLE_2FA] ? ButtonType.SUCCESS : ButtonType.PRIMARY}
                    title={((viewType == ViewType.PREVIEW && previewData?.[AdminUserField.ENABLE_2FA]) || (viewType != ViewType.PREVIEW && formData?.[AdminUserField.ENABLE_2FA])) ? 'Enable 2FA' : 'Disable 2FA'}
                    disabled={viewType == ViewType.PREVIEW || routePath == RouteEnum.ADMIN_USER_DETAILS}
                    onClick={(e: any) => {
                        if(setopenQRCodeModal) {
                            setopenQRCodeModal(true);
                        }
                    }} />
        </FormFieldItemsContainer>
    </CustomDetailsCard>
}
